<template>
  <page :load="doInit">
    <template slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              More Links...
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="sideMenuClick"></side-function-menu>
        </v-menu>
      </div>
    </template>
    <v-card>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs4>
              <v-checkbox class="queryValue" v-model="intermediary.interNoAe" style="display: inline-block;" disabled>{{ intermediary.interNoAe }}</v-checkbox>
              <v-flex style="display: inline-block; padding-top: 0px;">
                <v-subheader class="queryLabel">{{labels.inter}}</v-subheader>
              <div class="queryValue">{{intermediary.inter}}</div>
              </v-flex>
            </v-flex>
            <v-flex xs4>
              <v-subheader class="queryLabel">{{labels.interGroupName}}</v-subheader>
              <div class="queryValue">{{intermediary.interGroupName}}</div>
            </v-flex>
            <v-flex xs4>
              <v-subheader class="queryLabel">{{labels.intermediaryName}}</v-subheader>
              <div class="queryValue">{{intermediary.intermediaryName}}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <transition name="slide-x-transition" mode="out-in">
        <router-view :routerKey="routerKey"></router-view>
      </transition>
    </v-card>
  </page>
</template>

<script>
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
import { mapGetters, mapActions } from 'vuex'
import routeMixin from '@/mixins/route'

export default {
  data() {
    return {
      labels: {
        inter: 'Intermediary Reference',
        interGroupName: 'Intermediary Group',
        intermediaryName: 'Intermediary Name'
      },
      sideMenu: [
        { name: 'queryProfile', text: 'Profile', icon: 'mdi-account' },
        { name: 'queryCommissionMenu', text: 'Commission Rate', icon: 'mdi-folder-account' },
        { name: 'queryInterCurrPortfolioMenu', text: 'Current Portfolio', icon: 'mdi-folder-account' }
      ],
      sideFunction: [
        { text: 'Profile', icon: 'mdi-account', iconColor: 'primary', params: { key: 'queryProfile' } },
        { text: 'Commission Rate', icon: 'mdi-account', iconColor: 'primary', params: { key: 'queryCommissionMenu' } },
        { text: 'Current Portfolio', icon: 'mdi-account', iconColor: 'primary', params: { key: 'queryInterCurrPortfolioMenu' } }
      ],
      routerKey: undefined
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    intermediary() {
      return this.$store.state.adminInter.intermediary
    }
  },
  methods: {
    ...mapActions([
      'interMenuInit'
    ]),
    async doInit() {
      await this.interMenuInit(this.inter)
      this.routerKey = 'queryProfile'
    },
    sideMenuClick(data) {
      this.$router.push({ name: data.key, params: data.params })
    }
  },
  created() {
    this.intermediary.interNoAe = this.interNoAe === 'true'
  },
  props: ['inter', 'interNoAe'],
  components: {
    SideFunctionMenu
  },
  mixins: [
    routeMixin
  ]
}
</script>

<style lang="scss">
@import "../../../assets/scss/accounting.scss";
</style>
